'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTextMask = require('react-text-mask');

var _reactTextMask2 = _interopRequireDefault(_reactTextMask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var MaskedTextInput = function MaskedTextInput(_ref) {
  var field = _ref.field,
      value = _ref.value,
      _onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ['field', 'value', 'onChange']);

  return _react2.default.createElement(_reactTextMask2.default, _extends({}, rest, {
    className: 'form-control',
    value: value || '',
    onChange: function onChange(event) {
      return _onChange && _onChange(event.target.value);
    }
  }));
};

exports.default = MaskedTextInput;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbnB1dHMvTWFza2VkVGV4dElucHV0LmpzIl0sIm5hbWVzIjpbIk1hc2tlZFRleHRJbnB1dCIsImZpZWxkIiwidmFsdWUiLCJvbkNoYW5nZSIsInJlc3QiLCJldmVudCIsInRhcmdldCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7Ozs7OztBQUVBLElBQU1BLGtCQUFrQixTQUFsQkEsZUFBa0I7QUFBQSxNQUFHQyxLQUFILFFBQUdBLEtBQUg7QUFBQSxNQUFVQyxLQUFWLFFBQVVBLEtBQVY7QUFBQSxNQUFpQkMsU0FBakIsUUFBaUJBLFFBQWpCO0FBQUEsTUFBOEJDLElBQTlCOztBQUFBLFNBQ3RCLG9FQUNNQSxJQUROO0FBRUUsZUFBVSxjQUZaO0FBR0UsV0FBT0YsU0FBUyxFQUhsQjtBQUlFLGNBQVU7QUFBQSxhQUFTQyxhQUFZQSxVQUFTRSxNQUFNQyxNQUFOLENBQWFKLEtBQXRCLENBQXJCO0FBQUE7QUFKWixLQURzQjtBQUFBLENBQXhCOztrQkFTZUYsZSIsImZpbGUiOiJNYXNrZWRUZXh0SW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgTWFza2VkSW5wdXQgZnJvbSAncmVhY3QtdGV4dC1tYXNrJ1xuXG5jb25zdCBNYXNrZWRUZXh0SW5wdXQgPSAoeyBmaWVsZCwgdmFsdWUsIG9uQ2hhbmdlLCAuLi5yZXN0IH0pID0+IChcbiAgPE1hc2tlZElucHV0XG4gICAgey4uLnJlc3R9XG4gICAgY2xhc3NOYW1lPVwiZm9ybS1jb250cm9sXCJcbiAgICB2YWx1ZT17dmFsdWUgfHzCoCcnfVxuICAgIG9uQ2hhbmdlPXtldmVudCA9PiBvbkNoYW5nZSAmJiBvbkNoYW5nZShldmVudC50YXJnZXQudmFsdWUpfVxuICAvPlxuKVxuXG5leHBvcnQgZGVmYXVsdCBNYXNrZWRUZXh0SW5wdXRcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@geopagos/gp-forms/lib/inputs/MaskedTextInput.js
// module id = 243
// module chunks = 0